export const MAX_CSV_ROWS = 50000;
export const MAX_TEXT_CHARS = 500000;

const SPREADSHEET_EXTENSIONS = ["xlsx", "xls"];
const TEXT_EXTENSIONS = ["txt", "md", "markdown", "eml", "log", "text"];
const IMAGE_EXTENSIONS = ["png", "jpg", "jpeg", "gif", "webp", "bmp", "svg"];

export function getFileExtension(filename) {
  const ext = String(filename || "").split(".").pop() || "";
  return ext.toLowerCase();
}

/**
 * Resolve how a file should be previewed from its extension.
 * Returns one of: "pdf" | "csv" | "spreadsheet" | "text" | "json" | "docx" | "image" | "unsupported"
 */
export function getRenderType(filename) {
  const ext = getFileExtension(filename);
  if (ext === "pdf") return "pdf";
  if (ext === "csv") return "csv";
  if (SPREADSHEET_EXTENSIONS.includes(ext)) return "spreadsheet";
  if (TEXT_EXTENSIONS.includes(ext)) return "text";
  if (ext === "json") return "json";
  if (ext === "docx" || ext === "doc") return "docx";
  if (IMAGE_EXTENSIONS.includes(ext)) return "image";
  return "unsupported";
}

/**
 * RFC 4180-style CSV parser (quoted fields, escaped quotes, CRLF).
 * Stops once MAX_CSV_ROWS rows have been collected.
 */
export function parseCsvRows(text, maxRows = MAX_CSV_ROWS) {
  const rows = [];
  let row = [];
  let field = "";
  let inQuotes = false;
  const input = String(text || "");

  for (let i = 0; i < input.length && rows.length < maxRows + 1; i++) {
    const char = input[i];
    if (inQuotes) {
      if (char === '"') {
        if (input[i + 1] === '"') {
          field += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        field += char;
      }
    } else if (char === '"') {
      inQuotes = true;
    } else if (char === ",") {
      row.push(field);
      field = "";
    } else if (char === "\n" || char === "\r") {
      if (char === "\r" && input[i + 1] === "\n") i++;
      row.push(field);
      field = "";
      rows.push(row);
      row = [];
    } else {
      field += char;
    }
  }
  if (field !== "" || row.length > 0) {
    row.push(field);
    rows.push(row);
  }
  return rows.slice(0, maxRows);
}
